// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
}
#container app-side-navbar {
  position: fixed;
  width: 250px;
  height: 100vh;
  background: black;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
}
#container #content {
  flex-grow: 1;
  transition: 0.3s ease-in-out;
}
#container.sidebarActive app-side-navbar {
  transform: translateX(0);
}
#container.sidebarActive #content {
  margin-left: 250px;
  transition: 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/auth-tools/data-protection-authoring-tools/data-protection-authoring-tools.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACF;AAAE;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,4BAAA;EACA,sCAAA;AAEN;AACE;EACI,YAAA;EACA,4BAAA;AACN;AAGM;EAEI,wBAAA;AAFV;AAKM;EACI,kBAAA;EACA,4BAAA;AAHV","sourcesContent":["#container{\r\n  display: flex;\r\n  width: 100%;\r\n  height:100vh;\r\n  position: relative;\r\n  app-side-navbar{\r\n      position: fixed;\r\n      width:250px;\r\n      height: 100vh;\r\n      background: black;\r\n      transform: translateX(-100%);\r\n      transition: transform 0.3s ease-in-out;\r\n  }\r\n\r\n  #content{\r\n      flex-grow: 1;\r\n      transition:  0.3s ease-in-out ;\r\n  }\r\n\r\n  &.sidebarActive{\r\n      app-side-navbar{\r\n          \r\n          transform: translateX(0);\r\n         \r\n      }\r\n      #content{\r\n          margin-left: 250px;\r\n          transition: 0.3s ease-in-out;\r\n      }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
